export const SUPPORTS_OBJECT_PREVENT_EXTENSIONS = "preventExtensions" in Object;
